// extracted by mini-css-extract-plugin
export default {"dropzone":"dropzone__JQ77D","drag-active":"drag-active__FySA8","content":"content__4FCYz","active":"active__hrEMy"};